import React from "react";
import { mapValues } from "lodash";
import FormatCell from "../../components/app/Results/Cells/FormatCell";
import DataSheet from "../../components/app/Results/Cells/DataSheet";
import CAD from "../../components/app/Results/Cells/CAD";
import ECAD from "../../components/app/Results/Cells/ECAD";
import mosfetRelays from "./mosfet-relays";
import signalRelaysPowerRelays from "./signal-relay_power-relays";
import automotiveRelays from "./automotive-relays";
import flowSensors from "./flow-sensors";
import photomicroSensorsSeflectiveTypes from "./photomicro-sensors_reflective-types";
import photomicroSensorsTransmissiveTypes from "./photomicro-sensors_transmissive-types";
import connectors from "./connectors";
import automotiveBasicSwitches from "./automotive-basic-switches";
import dipSwitches from "./dip-switches";
import togglePushbuttonswitches from "./toggle_pushbutton-switches";
import pushbuttonSwitchesIndicators from "./pushbutton-switches_indicators";
import rockerSwitches from "./rocker-switches";
import tactileSwitches from "./tactile-switches";
import doorSwitchsPowerSwitches from "./door-switchs_power-switches";
import detectionSwitches from "./detection-switches";
import basicSwitches from "./basic-switches";
import Purchase from "../../components/app/Results/Cells/Purchase";
import appConfig from "../../../config";

/**
 * This variable is used to generate facet for non-common columns
 */
export const parametericFacetConfig = {
  "mosfet-relays": mosfetRelays,
  "signal-relay_power-relays": signalRelaysPowerRelays,
  "automotive-relays": automotiveRelays,
  "flow-sensors": flowSensors,
  "photomicro-sensors_reflective-types": photomicroSensorsSeflectiveTypes,
  "photomicro-sensors_transmissive-types": photomicroSensorsTransmissiveTypes,
  connectors: connectors,
  "automotive-basic-switches": automotiveBasicSwitches,
  "dip-switches": dipSwitches,
  "toggle_pushbutton-switches": togglePushbuttonswitches,
  "pushbutton-switches_indicators": pushbuttonSwitchesIndicators,
  "rocker-switches": rockerSwitches,
  "tactile-switches": tactileSwitches,
  "door-switchs_power-switches": doorSwitchsPowerSwitches,
  "detection-switches": detectionSwitches,
  "basic-switches": basicSwitches
};

/**
 * type ColumnConfig = {
 * field: string
 * label: string
 * Cell?: FunctionalComponent<{result}>
 * width?: string
 * isCSV?: boolean
 * csvTitle?: string
 * csvFormat?: Function({result}): text
 * isCheckbox?: boolean
 * isSortable?: boolean
 * }
 */

const commonFields1 = [
  {
    field: "thumbnail_text",
    label: "Thumb",
    hidden: true
  },
  {
    field: "operation",
    label: "Thumb",
    hidden: true
  },
  {
    field: "model_name",
    label: "Model Name",
    hidden: true
  },
  {
    field: "product_page_url",
    label: "Product Page Url",
    hidden: true,
    isCSV: false
  },
  {
    field: "id",
    label: "Format",
    Cell: ({ result }) => <FormatCell result={result} />,
    width: "8%",
    isCSV: true,
    csvTitle: "Format",
    csvFormat: ({ result }) => `${result.model_name.raw} ${result.thumbnail_text.raw}`,
    isCheckbox: true
  },
  {
    field: "shape_thumbnail_image",
    label: "Shape",
    isCSV: false,
    Cell: ({ result }) => (
      <td width="6%">
        <img src={result["shape_thumbnail_image"].raw} alt="" />
      </td>
    ),
    width: "6%"
  }
];

const commonFields2 = [
  {
    field: "caution_link",
    label: "Precaution",
    hidden: true,
    isSortable: true,
    isCSV: false
  },
  {
    field: "data_sheet_link",
    label: "Datasheet",
    Cell: ({ result }) => <DataSheet result={result} />,
    isCSV: false,
    csvTitle: "Datasheet",
    width: ""
  },
  {
    field: "cad_link",
    label: "2D/3D CAD",
    Cell: ({ result }) => <CAD result={result} />,
    width: "",
    isCSV: false,
    csvFormat: ({ result }) =>
      appConfig.isLoggedIn ? result["cad_link"].raw : ""
  },
  {
    field: "ecad_link",
    label: "ECAD",
    Cell: ({ result }) => <ECAD result={result} />,
    width: "",
    isCSV: false,
    csvFormat: ({ result }) =>
      appConfig.isLoggedIn ? result["ecad_link"].raw : ""
  },
  {
    field: "buyonline",
    label: "Buy Online",
    Cell: ({ result }) => <Purchase result={result} />,
    isCSV: false,
    csvTitle: "Buy Online",
    width: ""
  }
];

export const columnConfig = mapValues(parametericFacetConfig, columns => [
  ...commonFields1,
  ...columns,
  ...commonFields2
]);
